import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import React, { useEffect, useRef } from "react";
import Categories from "./categories";
import Contact from "./contact";
import Sponsoring from "./sponsoring";
import Offers from "./offers";
import CarouselCategories from "components/ui_components/CarouselCategories";
import MobileCarouselCategories from "components/ui_components/MobileCarouselCategories";
import Hero from "../components/ui_components/Hero";
import MobileHero from "components/ui_components/MobileHero";
import Skeleton from "react-loading-skeleton";
import { useWindowSize } from "helpers/scroll/animateScroll";
import { useGlobalState } from "../context/GlobalStateContext";
import Marketing from "./Marketing";
import { offerCardType } from "helpers/types";
import { IS_PRODUCTION_ENVIRONMENT } from "helpers/constants";
import { useRouter } from "next/router";

export async function getStaticProps({ locale }) {
  return {
    props: {
      isProduction: IS_PRODUCTION_ENVIRONMENT,
      ...(await serverSideTranslations(locale, [
        "hero",
        "layout",
        "about",
        "categories_carousel",
        "categories",
        "contact",
        "offers",
        "common",
        "marketing",
        "faq",
        "signup_promotion",
      ])),
    },
  };
}

function parseJwt(token) {
  return JSON.parse(Buffer.from(token.split(".")[1], "base64").toString());
}

export default function Home({ isProduction }) {
  const { language } = useGlobalState();
  const offersRef = useRef(null);
  const contactsRef = useRef(null);
  const router = useRouter();
  const size = useWindowSize();
  // UseEffect to handle scroll to contact section when href contain #contact
  useEffect(() => {
    let frame: number;
    const tryScroll = () => {
      if (router.asPath === "/#contact" && contactsRef.current) {
        const top = contactsRef.current.getBoundingClientRect().top;

        window.scrollTo({ top, behavior: "smooth" });
      } else {
        frame = requestAnimationFrame(tryScroll);
      }
    };

    frame = requestAnimationFrame(tryScroll);
    return () => cancelAnimationFrame(frame);
  }, [router.asPath]);

  return (
    <div className="landing-page-background-color">
      {size && size.width ? (
        <React.Fragment>
          {size.width > 1300 ? (
            <Hero lang={language} isProduction={isProduction} />
          ) : (
            <MobileHero lang={language} isProduction={isProduction} />
          )}
          {size.width > 760 ? <CarouselCategories lang={language} /> : <MobileCarouselCategories />}
          {/*{<About*/}
          {/*    clientsRef={clientsRef}*/}
          {/*    contactsRef={contactsRef}*/}
          {/*/>}*/}
          <Offers offersRef={offersRef} cardType={offerCardType.GENERIC} fromHomePage />
          <Marketing />
          <Categories />
          <Contact contactsRef={contactsRef} />
          <Sponsoring />
        </React.Fragment>
      ) : (
        <Skeleton className="h-screen" />
      )}
    </div>
  );
}
